<script>
import { CdrButton } from '@rei/cedar';
import { mapStores, mapWritableState } from 'pinia';
import { useWishlistStore } from '../../stores';

export default {
  name: 'PaginatorComponent',
  components: {
    CdrButton,
  },
  computed: {
    ...mapStores(useWishlistStore),
    ...mapWritableState(useWishlistStore, ['paginator']),
    shouldShowPrevious() {
      return this.wishlistStore.paginatorNumbers.counter >= this.wishlistStore.paginatorNumbers.itemsPerPage;
    },
    shouldShowNext() {
      return (
        this.wishlistStore.paginatorNumbers.counter + this.wishlistStore.paginatorNumbers.itemsPerPage <
        this.wishlistStore.wishlistEntries.length
      );
    },
    pageSelected() {
      return this.wishlistStore.paginatorNumbers.pageSelected;
    },
    pages() {
      return this.wishlistStore.paginatorNumbers.pages;
    },
  },
  methods: {
    goToNextPage() {
      this.paginator.counter += this.paginator.itemsPerPage;
      this.paginator.pageSelected += 1;
    },
    goToPreviousPage() {
      this.paginator.counter -= this.paginator.itemsPerPage;
      this.paginator.pageSelected -= 1;
    },
    goToPage(page) {
      this.paginator.pageSelected = page;
      this.paginator.counter = page * this.paginator.itemsPerPage;
    },
  },
};
</script>

<template>
  <div class="paginator">
    <ul class="paginator-container">
      <li v-if="shouldShowPrevious" class="paginator-container__item">
        <cdr-button class="paginator-container__button" modifier="link" @click="goToPreviousPage">
          &lt; Prev
        </cdr-button>
      </li>
      <li
        v-for="(page, index) in pages"
        :key="index"
        class="paginator-container__item"
        :class="{ 'paginator-container__item--selected': page === pageSelected }"
      >
        <cdr-button class="paginator-container__button" modifier="link" @click="goToPage(page)">
          {{ page + 1 }}
        </cdr-button>
      </li>
      <li v-if="shouldShowNext" class="paginator-container__item">
        <cdr-button class="paginator-container__button" modifier="link" @click="goToNextPage"> Next > </cdr-button>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens';
.paginator {
  margin-top: $cdr-space-one-and-a-half-x;
  &-container {
    display: flex;
    justify-content: center;
    padding: 0;
    &__button {
      color: $cdr-color-text-secondary;
      padding: $cdr-space-inset-three-quarter-x-squish;
      text-decoration: none;
    }
    &__item {
      list-style: none;
      &--selected {
        .paginator-container__button {
          border-bottom: 2px solid $cdr-color-text-info;
          border-radius: 0;
          color: $cdr-color-text-info;
          font-size: $cdr-text-heading-serif-200-size;
        }
      }
    }
  }
}
</style>
